import { render, staticRenderFns } from "./siteAdminLogForm.vue?vue&type=template&id=5f5116e5&scoped=true&"
import script from "./siteAdminLogForm.vue?vue&type=script&lang=js&"
export * from "./siteAdminLogForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5116e5",
  null
  
)

export default component.exports